// src/components/Elements/Button.jsx
import React from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';

export const Button = ({
  children,
  className,
  onClick,
  variant = 'solid',
  size = 'md',
  ...rest
}) => {
  const base =
    'inline-flex items-center justify-center font-semibold rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2';
  const sizes = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-6 py-2 text-base',
    lg: 'px-8 py-3 text-lg',
  };
  const styles = {
    solid: 'bg-[#F12C00] text-slate-200 hover:bg-[#9C2308] shadow-md',
    ghost: 'bg-transparent border border-slate-700 text-slate-100 hover:bg-slate-800/40',
  };
  return (
    <motion.button
      whileTap={{ scale: 0.97 }}
      whileHover={{ translateY: -2 }}
      className={clsx(base, sizes[size], styles[variant], className)}
      onClick={onClick}
      {...rest}
    >
      {children}
    </motion.button>
  );
};
